import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Stack } from '@mui/material';
import { listPrompts } from '../../../hooks/prompts';
import Item from './Item';

export default function Aside() {
  const { hash } = useLocation();

  const [items, setItems] = useState(null);

  useEffect(() => {
    setItems(null);
    listPrompts()
      .then((data) => setItems(data))
      .catch((error) => console.error('Failed to list prompts:', error));
  }, []);

  return (
    <Stack width={360} direction="column" my={8}>
      {items?.map((v) => (
        <Item
          key={`prompt-${v.id}`}
          id={v.id}
          title={v.title}
          description={v.description}
          active={hash === `#${v.id}`}
        />
      ))}
    </Stack>
  );
}
